import { render, staticRenderFns } from "./MySummary.vue?vue&type=template&id=4c5088bd"
import script from "./MySummary.vue?vue&type=script&lang=js"
export * from "./MySummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports